import script from "./MessagesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MessagesPage.vue?vue&type=script&setup=true&lang=js"

import "./MessagesPage.vue?vue&type=style&index=0&id=89b383ba&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-89b383ba"]])

export default __exports__